import { useItem } from '@/composables/item'
import noteTypeService from '@/services/api/notetype'
import { defineStore, acceptHMRUpdate } from 'pinia'

export const useNoteTypeStore = defineStore('noteType', () => {
	const { items, show, create, update, remove } = useItem(
		noteTypeService,
		'notestype'
	)

	const load = noteTypeService.index

	return {
		items,
		show,
		create,
		update,
		remove,
		load,
	}
})

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useNoteTypeStore, import.meta.hot))
}
